let urlHead = 'https://api.sponlax.com' //接口地址 默认正式

// 如果是不是测试或者本地
if (
  window.location.href.includes('https://russia.rakumart.cn') ||
  window.location.href.includes('http://localhost')
) {
  urlHead = 'https://russiaapi.rakumart.cn'
} else {
  // 如果不是全部用正式
  urlHead = 'https://api.sponlax.com'
}
// urlHead = 'https://api.sponlax.com'
// https://api.sponlax.com 正式
// https://russiaapi.rakumart.cn 测试
export default urlHead
